var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TheInput',{on:{"changeStatus":_vm.changeStatus,"changeResult":_vm.changeResult}}),_c('TheOutput',{attrs:{"status":_vm.status,"result":_vm.result}}),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }